import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
import { Button, Form, FormGroup } from "reactstrap";
import { InputText, Validations, Loading, Valert } from "../components";
import { statusEnum } from "../actions/constant";
import forgotPasswordActions from "../actions/forgotPasswordActions";
import queryString from "../services/QueryStringService";
import i18n from "../i18n";
import {
  isLoadedFromMobile,
  getCurrentOrientation,
} from "../services/MobileService";
import { Orientations } from "./PageConstants";

import "./styles/homePage.css";
import "./styles/authModern.css";

let ForgotPasswordForm = (props) => {
  const { t } = props;

  return (
    <Form onSubmit={props.handleSubmit}>
      <FormGroup>
        <InputText
          type="text"
          placeholder={t("general.EMAIL_OR_PHONE")}
          invalid={Validations.email(props.emailField)}
          input={{
            onChange: (e) => props.onChangeForm(e),
            name: "email",
            value: props.emailField,
          }}
          meta={{
            touched: true,
            error: Validations.email(props.emailField),
          }}
        />
      </FormGroup>
      <div className="submit2 row justify-content-between">
        <div className="col">
          <Button
            className="button-submit"
            color="primary"
            onClick={props.onCancel}
          >
            {t("general.CANCEL")}
          </Button>
        </div>
        <div className="col">
          <Button
            className="button-submit"
            disabled={
              !props.emailField || Validations.email(props.emailField)
                ? true
                : false
            }
            color="primary"
            onClick={props.onSubmit}
          >
            {t("general.SUBMIT")}
          </Button>
        </div>
      </div>
    </Form>
  );
};

ForgotPasswordForm = reduxForm({
  form: "formForgotPassword",
})(ForgotPasswordForm);

class ForgotPassword extends Component {
  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.email && values.key) {
      this.props.history.push({
        pathname: "/forgotpasswordreset",
        state: { values: values },
      });
      //this.props.history.push({ pathname: `/forgotpasswordreset`, state: { values: values } });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.status === statusEnum.SUCCESS) {
      //setTimeout(() => this.props.history.push('/'), 2000);
    }
  }

  componentWillMount() {
    this.props.setDefaultState();
  }

  handleSubmit(values) {
    const getUrl = window.location;
    const baseUrl = getUrl.protocol + "//" + getUrl.host;
    const lang = i18n.language;
    const user = { email: this.props.emailField };
    user.step = 1;
    if (lang === "zh-CN") {
      user.lang = "1200000000001000015";
    } else if (lang === "zh-TW") {
      user.lang = "1200000000001000016";
    } else {
      user.lang = "1200000000001000022";
    }
    user.forgot_password_site_url = baseUrl + `/forgotpasswordreset/${user.lang}`;
    this.props.forgotPasswordSubmit(user);
  }

  cancelClicked() {
    window.location.href = "/";
    localStorage.setItem("i18nextLng", i18n.language);
  }

  render() {
    const { isLoading, t } = this.props;
    var _pageFitter;
    if (
      isLoadedFromMobile() ||
      getCurrentOrientation() === Orientations.PORTRAIT
    ) {
      _pageFitter = "page-fitter-mobile";
    } else {
      _pageFitter = "page-fitter-non-navbar";
    }

    return (
      <div className={`${_pageFitter} auth-modern`}>
        <div className="page-wrapper">
          <Valert
            display={this.props.passResetSuccess}
            title={t("forgot.PASSWORD_RECOVERY_LINK_TITLE")}
            question={t("forgot.PASSWORD_RECOVERY_LINK_TEXT")}
            positiveAction={() => {
              window.location.reload(),
                localStorage.setItem("i18nextLng", i18n.language);
            }}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />
          <Valert
            display={this.props.passResetFailed}
            title={t("forgot.UNREGISTERED_EMAIL_TITLE")}
            question={t("forgot.UNREGISTERED_EMAIL_TEXT")}
            // positiveAction={() => {
            //   window.location.reload();
            // }}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />
          <Loading isLoading={isLoading} />
          <div className="row justify-content-center">
            <div className="login-box col-lg-4 col-md-6">
              <p className="forgot-title">{t("forgot.TITLE")}</p>

              <ForgotPasswordForm
                onSubmit={this.handleSubmit.bind(this)}
                onCancel={this.cancelClicked.bind(this)}
                t={t}
                onChangeForm={this.props.onChangeForm}
                emailField={this.props.emailField}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword = translate("translations")(ForgotPassword);

const mapStateToProps = (state) => ({ ...state.forgotPassword });

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...forgotPasswordActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword.js